var map = {
	"./qld/birthplace": 539,
	"./wa/birthplace": 545
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 504;


//////////////////
// WEBPACK FOOTER
// ../data ^\.\/.*\/birthplace$
// module id = 504
// module chunks = 0